<template>
  <div>
    <public-announcement />
    <div class="flex items-center justify-center min-h-screen p-4 overflow-hidden">
      <div class="relative z-10 w-108">
        <MultipleLanguage class="mt-1" />
        <div class="flex items-center justify-center h-28">
          <span class="">
            <a href="https://ahaslides.com">
              <aha-logo
                width="150"
                height="34"
              />
            </a>
          </span>
        </div>

        <div class="p-8 shadow-panel lg:p-8 rounded-3xl bg-base-0">
          <h2 class="text-center">
            {{ $i18nPresenter.t('Single Sign On') }}
          </h2>

          <SSOForm />

          <p class="mb-4 text-sm text-center">
            {{ $i18nPresenter.t('Want to use Single Sign On for your team') }} ?<br>
            <a
              class="font-bold primary cursor-pointer"
              @click="openModalSpeakToUs"
            >{{ $i18nPresenter.t('Speak to our Enterprise team') }}</a>
          </p>

          <div class="border-b border-base-30"></div>

          <p class="mt-4 text-sm text-center">
            <router-link
              :to="{
                path: '/pages/login',
                query: { ...$route.query }
              }"
              class="font-bold primary"
            >
              {{ $i18nPresenter.t('Log in without SSO') }}
            </router-link>
          </p>
        </div>
        <SpeakToUsModal
          v-if="!canUseNewEnterpriseInquiriesForm"
          :is-open-modal="isOpenModalSpeakToUs"
          @hide="isOpenModalSpeakToUs = false"
        />
        <EnterpriseInquiriesFormModal
          v-else
          :is-open-modal="isOpenModalSpeakToUs"
          @hide="isOpenModalSpeakToUs = false"
        />

        <span class="absolute hidden lg:block -left-24 bottom-18">
          <img src="@/assets/images/elements/trophy.svg">
        </span>

        <div class="h-28" />
      </div>

      <back-drop :wandElement="false" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BackDrop from '@/components-v2/common/auth/BackDrop.vue'
import SSOForm from '@/components-v2/sso/SSOForm.vue'
import PublicAnnouncement from '@/components-v2/common/global-notification/PublicAnnouncement.vue'
import MultipleLanguage from '@/components-v2/multiple-language/MultipleLanguage.vue'

// containers
import SSOFormContainer from '@/containers/sso/SSOForm'

import cookie from '@/services/cookie'
import { AHA_GUEST_USER } from '@/constant/storageKeys'
import SpeakToUsModal from '@/components-v2/my-plan/user-pricing-v3/SpeakToUsModal.vue'
import EnterpriseInquiriesFormModal from '@/components-v2/my-plan/user-pricing-v3/EnterpriseInquiriesFormModal.vue'

export default {
  components: {
    SpeakToUsModal,
    EnterpriseInquiriesFormModal,
    BackDrop,
    SSOForm: SSOFormContainer(SSOForm),
    PublicAnnouncement,
    MultipleLanguage,
  },
  data() {
    return {
      isOpenModalSpeakToUs: false,
    }
  },

  computed: {
    ...mapGetters('featureToggles', ['canUseNewEnterpriseInquiriesForm']),
  },

  async created() {
    // This is the main entry point for the SSO page. It initializes the page and checks if the user is already logged in.
    this.isGuest = !!cookie.getValue(AHA_GUEST_USER)
    if (cookie.getValue('ahaToken') && !this.isGuest) {
      this.$router.push('/apps/home')
    }
  },
  methods: {
    openModalSpeakToUs() {
      // event default

      this.isOpenModalSpeakToUs = true
    },
  },
}
</script>
